<!--
    描述：订阅查看工具-对比tab页列表页面
    时间：2020-06-16
    Created by yefan
-->
<template>
	<div class="w-page-main comparison-main">
		<div class="w-page-header">
			<div class="left-tabs">
				<el-button-group>
					<el-button size="small"
							   :class="{'isActive': activeTab1 === 'price'}"
							   @click="handleClick('price')">价格
					</el-button>
					<el-button size="small"
							   :class="{'isActive': activeTab1 === 'trend'}"
							   @click="handleClick('trend')"
							   class="ml10">走势
					</el-button>
					<el-button size="small"
							   :class="{'isActive': activeTab1 === 'compare1'}"
							   @click="handleClick('compare1')"
							   class="ml10">同比
					</el-button>
					<el-button size="small"
							   :class="{'isActive': activeTab1 === 'compare2'}"
							   @click="handleClick('compare2')"
							   class="ml10">环比
					</el-button>
				</el-button-group>
			</div>

			<div class="btnGroups">
				<el-button-group>
					<el-button size="small"
							   :class="{'isActive': activeTab2 === '1'}"
							   @click="changePriceType('1')">信息价
					</el-button>
					<el-button size="small"
							   :class="{'isActive': activeTab2 === '2'}"
							   @click="changePriceType('2')">市场价
					</el-button>
				</el-button-group>
			</div>
		</div>

		<div class="w-page-container"
			 v-loading="loading">
			<!-- 上方过滤条件 -->
			<div class="comparison-header">
				<div class="comparison-header-left">
					<span class="header-title">主要材料:</span>
					<!-- 材料 -->
					<el-tooltip v-for="(tag, index) in materialTags"
								:key="tag.id"
								:disabled="tag.resourceType !== 2">
						<div slot="content"
							 class="info-box">
							<p>材料组成：</p>
							<p v-for="(m, n) in tag.resources"
							   :key="'组合具体材料' + n">
								{{ m.sname }}
							</p>
						</div>
						<!-- 具体标签 -->
						<el-tag closable
								class="material-tag"
								:class="{active: tag.isActive}"
								:disable-transitions="false"
								@click="handleClickTag(tag)"
								@close.stop="handleCloseTag(tag)">
							{{ tag.sname }}
						</el-tag>
					</el-tooltip>
					<el-button size="small"
							   @click="addMaterials"
							   class="ml10">+ 添加材料
					</el-button>
				</div>
				<!-- 走势 -->
				<div class="comparison-header-center"
					 v-if="activeTab1 === 'trend'">
					<el-radio-group v-model="curLineType"
									@change="onChangeLineType">
						<el-radio :label="1">走势</el-radio>
						<el-radio :label="2">涨跌幅</el-radio>
					</el-radio-group>

					<el-date-picker v-model="monthArr"
									type="monthrange"
									size="small"
									@change="handleChange"
									format="yyyy-MM"
									value-format="yyyy-MM"
									style="width: 250px"
									range-separator="-"
									start-placeholder="开始月份"
									end-placeholder="结束月份">
					</el-date-picker>
					<el-button size="small"
							   type="primary"
							   class="ml10"
							   @click="doPreview">导出图片
					</el-button>
				</div>
				<!-- 非走势 -->
				<div class="comparison-header-right"
					 v-else>
					<el-radio-group v-model="curLineType"
									v-if="activeTab1 !== 'price'"
									class="mr20"
									@change="onChangeLineType">
						<el-radio :label="1">走势</el-radio>
						<el-radio :label="2">涨跌幅</el-radio>
					</el-radio-group>
					<span>当前年月：</span>
					<el-date-picker v-model="curDate"
									type="month"
									@change="handleChange"
									size="small"
									format="yyyy-MM"
									value-format="yyyy-MM"
									style="width: 150px"
									placeholder="选择月">
					</el-date-picker>
					<el-button size="small"
							   type="primary"
							   class="ml10"
							   @click="doPreview">导出图片
					</el-button>
				</div>
			</div>

			<!-- 下方图表 -->
			<div class="comparison-chart"
				 id="myChart"></div>

			<!-- 下方表格 + 标题 -->
			<div class="comparison-header">
				<div class="comparison-header-left">
					<span class="header-title">详细价格
						<span v-if="activeTab1 !== 'price'">{{ '  ---  ' + this.activeCodeName }}</span>
						<span v-if="activeTab1 === 'trend'">{{ this.curLineType === 1 ? ' --- 走势' : ' --- 涨跌幅' }}</span>
					</span>
				</div>
				<div class="comparison-header-right">
					<el-button size="small"
							   type="primary"
							   class="ml10"
							   @click="doExport">导出Excel
					</el-button>
				</div>
			</div>
			<!-- 价格tab 页 表格 -->
			<div class="w-table-layout"
				 v-if="activeTab1 === 'price'">
				<div class="w-table-content">
					<el-table :data="tableObj.showData"
							  highlight-current-row
							  v-loading="loading"
							  stripe
							  border>
						<el-table-column label="材料名称"
										 align="center"
										 prop="name"
										 show-overflow-tooltip
										 min-width="100">
							<template slot-scope="scope">
								<el-tooltip :disabled="scope.row.resourceType !== 2"
											placement="bottom">
									<div slot="content"
										 class="info-box">
										<p>材料组成：</p>
										<p v-for="(item, index) in scope.row.relateMaterials"
										   :key="'材料组成' + index">
											{{ `${item.name}  ---  权重：${item.weight} %` }}
										</p>
									</div>
									<div>{{ scope.row.name }}</div>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column label="规格 / 型号"
										 show-overflow-tooltip
										 prop="specification"
										 header-align="center"
										 min-width="100"></el-table-column>
						<el-table-column v-for="(item, index) in tableObj.headerColumns"
										 :key="'header' + index"
										 :label="item.cityName"
										 show-overflow-tooltip
										 header-align="center"
										 align="right"
										 min-width="100">
							<template slot-scope="scope">
								<div>{{ scope.row.data[index] === '/' ? '0.00' : scope.row.data[index] }}</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>

			<!-- 走势/同比/环比 tab 页表格 -->
			<div class="w-table-layout"
				 v-else>
				<div class="w-table-content">
					<el-table :data="tableObj.showData"
							  highlight-current-row
							  v-loading="loading"
							  stripe
							  border>
						<el-table-column label="月份"
										 align="center"
										 prop="month"
										 show-overflow-tooltip
										 min-width="100">
							<template slot-scope="scope">
								<div>{{ scope.row.month }}</div>
							</template>
						</el-table-column>
						<el-table-column v-for="(item, index) in tableObj.headerColumns"
										 :key="'header' + index"
										 :label="item.cityName"
										 show-overflow-tooltip
										 header-align="center"
										 align="right"
										 min-width="100">
							<template slot-scope="scope">
								<div>{{ scope.row.data[index] === '/' ? '0.00' : scope.row.data[index] }}</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>

		<!-- Modal -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :close-on-click-modal="false"
				   @closed="handleClose">
			<!-- 内容区域 -->
			<div class="h100 overflow-hidden">
				<!-- 新增材料 -->
				<add-materials ref="materialsAdd"
							   v-if="dialogObj.type === 'add'"
							   @onSave="onAddSubmit"></add-materials>
				<!-- 导出图片预览 -->
				<div v-if="dialogObj.type === 'bigChart'"
					 class="bigChart-box"
					 id="bigChart"></div>
			</div>

			<!-- 底部按钮 -->
			<div slot="footer"
				 class="dialog-footer text-center">
				<el-button @click="handleClose"
						   size="small">取 消
				</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doConfirm">确 定
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import addMaterials from './components/addMaterials'
import {
	getMaterialCategorys,
	getPricesOfMaterials,
	getPricesOfTrend,
	getPricesOfCompare,
	deleteMainMaterial,
	exportMainMaterialPrice
} from '@/api/modules/resource.js'
import { dateFormat, exportExcel } from '@/utils/tools'

export default {
	components: {
		addMaterials
	},
	data() {
		return {
			activeTab1: 'price',
			activeTab2: '1', // 1 信息价  2 市场价
			loading: false,
			// 材料tag 数组
			materialTags: [],
			// 图表数据
			chartObj: {
				showData: [], // 展示的 数据
				priceData: [], // 走势数据
				rateData: [] // 涨跌幅数据
			},
			// 表格数据
			tableObj: {
				showData: [], // 表格数据
				headerColumns: [] // 表格动态表头
			},
			// 当前 图线类型 （1 是走势， 2 是涨跌幅）
			curLineType: 1,
			// 当前 年月
			curDate: dateFormat('yyyy-MM'),
			// 走势 tab 页 开始 -- 结束年月
			monthArr: [dateFormat('yyyy-MM'), dateFormat('yyyy-MM')],
			startMonth: dateFormat('yyyy-MM'),
			endMonth: dateFormat('yyyy-MM'),
			// 当前点击的 主材编码
			activeCode: '',
			activeCodeName: '',
			// 当前点击的 主材类型（材料还是组合）
			curObj: {
				resourceId: '',
				resourceType: ''
			},
			// 导出大图的 文件名
			exportName: '',
			// 弹窗对象
			dialogObj: {
				title: '添加主要材料',
				visible: false,
				width: '80%',
				type: ''
			},
			btnLoading: false
		}
	},
	methods: {
		// 根据价格类型 和 当前月份加载数据
		getPageData() {
			// 全部置空
			this.loading = true
			this.chartObj.showData = []
			this.tableObj.showData = []
			this.tableObj.headerColumns = []
			this.curLineType = 1

			// 根据不同的 tab 标签查询不同接口
			switch (this.activeTab1) {
				case 'price':
					getPricesOfMaterials({
						priceType: this.activeTab2,
						yearAndMonth: this.curDate
					})
						.then(res => {
							// 主要材料展示
							res.data.mainMaterials.map(x => (x.isActive = true))
							this.materialTags = res.data.mainMaterials

							// 渲染图
							this.chartObj.showData = res.data.cityPrices
							this.initPriceCharts()

							// 渲染表格
							this.tableObj.showData = res.data.materialPrices
							this.tableObj.headerColumns = res.data.citys

							this.loading = false
						})
						.catch(err => {
							this.loading = false
						})
					break
				case 'trend':
					// 非价格tab 页， 置空主材选择
					if (
						this.activeCode === '' &&
						this.materialTags.length > 0
					) {
						this.materialTags.map(x => (x.isActive = false))
						this.materialTags[0].isActive = true

						this.activeCode = this.materialTags[0].code
						this.activeCodeName = this.materialTags[0].sname

						// 当前是否是组合
						this.curObj.resourceId = this.materialTags[0].id
						this.curObj.resourceType = this.materialTags[0].resourceType
					}

					getPricesOfTrend({
						startMonth: this.startMonth,
						endMonth: this.endMonth,
						priceType: this.activeTab2,
						sysCode: this.activeCode,
						resourceId: this.curObj.resourceId,
						resourceType: this.curObj.resourceType
					})
						.then(res => {
							// 渲染图 --- 默认走势
							this.chartObj.showData = res.data.monthPrices
							this.initTrendCharts(
								res.data.citys,
								res.data.monthPrices
							)

							// 数据缓存（走势 / 涨跌幅）
							this.chartObj.priceData = res.data.monthPrices
							this.chartObj.rateData = res.data.monthGrowthRates

							// 渲染表格
							this.tableObj.showData = res.data.monthPrices
							this.tableObj.headerColumns = res.data.citys

							this.loading = false
						})
						.catch(err => {
							this.loading = false
						})
					break
				default:
					let _type = this.activeTab1 === 'compare1' ? '1' : '2'

					// 非价格tab 页， 置空主材选择
					if (
						this.activeCode === '' &&
						this.materialTags.length > 0
					) {
						this.materialTags.map(x => (x.isActive = false))
						this.materialTags[0].isActive = true

						this.activeCode = this.materialTags[0].code
						this.activeCodeName = this.materialTags[0].sname

						// 当前是否是组合
						this.curObj.resourceId = this.materialTags[0].id
						this.curObj.resourceType = this.materialTags[0].resourceType
					}

					getPricesOfCompare({
						type: _type, // 1是同比， 2是环比
						priceType: this.activeTab2,
						yearAndMonth: this.curDate,
						sysCode: this.activeCode,
						resourceId: this.curObj.resourceId,
						resourceType: this.curObj.resourceType
					})
						.then(res => {
							// 渲染图 --- 默认走势
							this.chartObj.showData = res.data.monthPrices
							this.initCompareCharts(
								res.data.monthPrices,
								res.data.cityPrices
							)

							// 数据缓存（走势 / 涨跌幅）
							this.chartObj.priceData = JSON.parse(
								JSON.stringify(res.data.monthPrices)
							)
							this.chartObj.rateData = res.data.priceRates

							// 渲染表格
							this.tableObj.showData = res.data.monthPrices
							this.tableObj.headerColumns = res.data.cityPrices

							// 表格加入涨跌幅行
							let obj = {
								month: '涨跌幅',
								data: res.data.priceRates
							}
							this.tableObj.showData.push(obj)

							this.loading = false
						})
						.catch(err => {
							this.loading = false
						})
					return
			}
		},

		// 左侧功能 点击 -- tab切换
		handleClick(val) {
			this.activeCode = ''
			this.activeTab1 = val

			// 不同tab 类型 调用函数
			this.getPageData()
		},

		// 材料 tag 点击事件
		handleClickTag(tag) {
			this.activeCodeName = tag.sname || ''

			// 如果不是 价格，其它的置为 false
			if (this.activeTab1 !== 'price') {
				this.activeCode = tag.code || null
				this.materialTags.map(x => (x.isActive = false))
			}
			tag.isActive = !tag.isActive

			let myChart = this.$echarts.init(document.getElementById('myChart'))
			if (this.activeTab1 === 'price') {
				// 图例显示状态切换
				myChart.dispatchAction({
					type: 'legendToggleSelect',
					// 图例名称
					name: tag.sname
				})
			} else {
				this.curObj.resourceId = tag.id
				this.curObj.resourceType = tag.resourceType
				// 走势 不同材料切换 调接口
				this.getPageData()
			}
		},

		// 材料 tag 数组点击关闭
		handleCloseTag(tag) {
			let _index = this.materialTags.findIndex(x => x.id === tag.id)

			if (_index > -1) {
				this.materialTags.splice(_index, 1)
			}

			// 设置activeCode
			if (this.materialTags.length === 0) {
				this.activeCode = ''
				this.activeCodeName = ''
				this.curObj.resourceId = ''
				this.curObj.resourceType = ''
			}

			if (tag.code === this.activeCode) {
				let _item =
					this.materialTags.length > 0
						? this.materialTags[this.materialTags.length - 1]
						: ''
				_item !== '' ? this.handleClickTag(_item) : ''
			}

			deleteMainMaterial({
				type: 1, // 1 是材料 2是人工
				resourceId: tag.id,
				resourceType: tag.resourceType
			})
				.then(res => {
					this.$message.success('删除成功!')
					// 保存成功刷新数据
					this.getPageData()
				})
				.catch(err => {
					// this.$emit('onSave')
				})
		},

		// 切换 价格显示类型
		changePriceType(type) {
			this.activeTab2 = type

			this.getPageData()
		},

		// 切换 走势/涨跌幅 单选
		onChangeLineType(val) {
			// 走势
			if (val === 1) {
				if (this.activeTab1 === 'trend') {
					this.initTrendCharts(
						this.tableObj.headerColumns,
						this.chartObj.priceData
					)
					this.tableObj.showData = this.chartObj.priceData
				} else {
					this.initCompareCharts(
						this.chartObj.priceData,
						this.tableObj.headerColumns
					)
				}
			} else {
				// 涨跌幅
				if (this.activeTab1 === 'trend') {
					this.initTrendCharts(
						this.tableObj.headerColumns,
						this.chartObj.rateData,
						true
					)
					this.tableObj.showData = this.chartObj.rateData
				} else {
					this.initCompareCharts(
						this.chartObj.rateData,
						this.tableObj.headerColumns,
						true
					)
				}
				// this.tableObj.showData = this.chartObj.rateData
			}
		},

		// 切换当前月份
		handleChange(val) {
			if (this.activeTab1 === 'trend') {
				this.startMonth = val[0] || ''
				this.endMonth = val[1] || ''
			}
			// 重新获取接口
			this.getPageData()
		},

		// 点击添加材料
		addMaterials() {
			this.dialogObj.visible = true
			this.dialogObj.type = 'add'
			this.dialogObj.title = '添加主要材料'
		},

		// 弹窗确认事件
		doConfirm() {
			if (this.dialogObj.type === 'add') {
				this.btnLoading = true
				this.$refs.materialsAdd.doSubmit()
			} else {
				// 导出大图
				this.saveAsPng('bigChart', this.exportName)
			}
		},

		// 弹窗关闭事件
		handleClose() {
			this.dialogObj.visible = false
			this.btnLoading = false
			this.dialogObj.type = ''
		},

		// 主材料 确定添加后事件
		onAddSubmit(arr) {
			if (this.activeTab1 !== 'price' && arr) {
				this.activeCode = ''
				this.materialTags = arr
			}
			this.getPageData()
			this.handleClose()
		},

		// 渲染图表 --- 价格
		initPriceCharts(isBigChart) {
			let myChart = isBigChart
				? this.$echarts.init(document.getElementById('bigChart'))
				: this.$echarts.init(document.getElementById('myChart'))

			// 先清除画布
			myChart.clear()

			// 第一条 类型字段
			let dataList = [['city']]
			let seriesList = []

			this.materialTags.map(x => {
				dataList[0].push(x.sname)

				let type = {
					type: 'bar'
				}
				seriesList.push(type)
			})

			// 具体数据
			this.chartObj.showData.map(x => {
				let arr = []
				arr.push(x.cityName)

				x.data.map(y => {
					let val = y === '/' ? '0.00' : parseFloat(y)
					arr.push(val)
				})

				dataList.push(arr)
			})

			let option = {
				legend: {
					show: isBigChart,
					type: 'scroll'
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					formatter: function(params) {
						let str = params[0].name
						params.map((x, index) => {
							str +=
								'</br>' +
								x.marker +
								' ' +
								x.seriesName +
								' : ' +
								x.value[index + 1] +
								' 元'
						})
						return str
					}
				},
				grid: {
					top: 30,
					left: '3%',
					right: '4%',
					bottom: '30',
					containLabel: true
				},
				dataset: {
					source: dataList
				},
				xAxis: {
					type: 'category',
					axisLabel: { interval: 0 } // 坐标轴标签间 刻度，0 表示强制全部显示
				},
				yAxis: {
					type: 'value',
					name: '单位：元',
					// min: 0,
					// max: 250,
					interval: 10
					// axisLabel: {
					// 	formatter: '{value} 元'
					// }
				},
				// Declare several bar series, each will be mapped
				// to a column of dataset.source by default.
				series: seriesList
			}

			// 大图配置参数
			if (isBigChart) {
				let _date = new Date(this.curDate)
				let _month =
					_date.getFullYear() + '年' + (_date.getMonth() + 1) + '月'
				let title = _month + '全省主要材料价格对比'
				// 导出文件名
				this.exportName = title
				// 标题
				option.title = {
					text: title,
					left: 'center'
				}
				// 图表间距
				option.grid = {
					top: 70,
					left: 50,
					right: 50,
					bottom: 30
				}
				// 图例
				option.legend = {
					top: 30,
					type: 'scroll'
				}
			}

			myChart.setOption(option)

			if (myChart) {
				window.addEventListener('resize', () => {
					myChart.resize()
				})
			}
		},

		// 渲染图表 --- 走势
		initTrendCharts(citys, sourceData, chartType, isBigChart) {
			let myChart = isBigChart
				? this.$echarts.init(document.getElementById('bigChart'))
				: this.$echarts.init(document.getElementById('myChart'))
			// 先清除画布
			myChart.clear()

			// 第一条 类型字段
			let dataList = [['city']]
			let seriesList = []
			let sname = this.activeCodeName

			citys.map(x => {
				dataList[0].push(x.cityName)

				let type = {
					type: 'line'
				}
				seriesList.push(type)
			})

			// 具体数据
			sourceData.map(x => {
				let arr = []
				arr.push(x.month)

				x.data.map(y => {
					let val =
						y === '/'
							? '0.00'
							: (Math.random().mul(100) - 50).toFixed(2)
					arr.push(val)
				})

				dataList.push(arr)
			})

			let option = {
				legend: {
					type: 'scroll',
					left: '6%',
					right: '4%',
					icon: 'circle'
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					confine: true, // 是否将 提示框限定在 图表内
					formatter: function(params) {
						let str = params[0].name + '---' + sname
						let unit = chartType ? ' %' : ' 元'
						params.map((x, index) => {
							index % 2 === 0 ? (str += '</br>') : ''
							str +=
								'<span style="display: inline-block; width: 150px">' +
								x.marker +
								' ' +
								x.seriesName +
								' : ' +
								x.value[index + 1] +
								unit +
								'</span>'
						})
						return str
					}
				},
				grid: {
					top: 30,
					left: 20,
					right: 20,
					bottom: '30',
					containLabel: true
				},
				dataset: {
					source: dataList
				},
				xAxis: {
					type: 'category',
					axisLabel: { interval: 0 } // 坐标轴标签间 刻度，0 表示强制全部显示
				},
				yAxis: {
					type: 'value',
					name: chartType ? '单位：%' : '单位：元',
					interval: 10
				},
				series: seriesList
			}

			// 大图配置参数
			if (isBigChart) {
				let _startDate = new Date(this.startMonth)
				let _endDate = new Date(this.endMonth)
				let _month =
					_startDate.getFullYear() +
					'年' +
					(_startDate.getMonth() + 1) +
					'月' +
					'~' +
					_endDate.getFullYear() +
					'年' +
					(_endDate.getMonth() + 1) +
					'月'
				let typeName = this.curLineType === 1 ? '走势' : '涨跌幅'
				let title =
					_month + `全省${this.activeCodeName}材料价格${typeName}对比`
				// 导出文件名
				this.exportName = title
				// 标题
				option.title = {
					text: title,
					left: 'center'
				}
				// 图表间距
				option.grid = {
					top: 70,
					left: 50,
					right: 50,
					bottom: 30
				}
				// 图例
				option.legend = {
					top: 30,
					type: 'scroll',
					left: 90,
					right: '4%',
					icon: 'circle'
				}
			}

			myChart.setOption(option)

			if (myChart) {
				window.addEventListener('resize', () => {
					myChart.resize()
				})
			}
		},

		// 渲染图标 --- 同比、环比
		initCompareCharts(months, sourceData, chartType, isBigChart) {
			let myChart = isBigChart
				? this.$echarts.init(document.getElementById('bigChart'))
				: this.$echarts.init(document.getElementById('myChart'))
			// 先清除画布
			myChart.clear()

			// 第一条 类型字段
			let dataList = [['city']]
			let seriesList = []
			let sname = this.activeCodeName

			if (chartType) {
				dataList[0].push('涨跌幅')
				let type = {
					type: 'bar'
				}
				seriesList.push(type)

				// 具体数据
				sourceData.map((x, index) => {
					let arr = []
					arr.push(x.cityName)
					arr.push(parseFloat(months[index]))

					dataList.push(arr)
				})
			} else {
				months.map(x => {
					dataList[0].push(x.month)

					let type = {
						type: 'bar'
					}
					seriesList.push(type)
				})

				// 具体数据
				sourceData.map(x => {
					let arr = []
					arr.push(x.cityName)

					x.data.map(y => {
						let val =
							y === '/'
								? 0
								: (Math.random().mul(100) - 50).toFixed(2)
						arr.push(val)
					})

					dataList.push(arr)
				})
			}

			let option = {
				legend: {
					type: 'scroll',
					icon: 'circle'
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					confine: true, // 是否将 提示框限定在 图表内
					formatter: function(params) {
						let str = params[0].name + '---' + sname
						let unit = chartType ? ' %' : ' 元'
						params.map((x, index) => {
							str +=
								'</br>' +
								'<span style="display: inline-block; width: 150px">' +
								x.marker +
								' ' +
								x.seriesName +
								' : ' +
								parseFloat(x.value[index + 1]) +
								unit +
								'</span>'
						})
						return str
					}
				},
				grid: {
					top: 30,
					left: 30,
					right: 20,
					bottom: '30',
					containLabel: true
				},
				dataset: {
					source: dataList
				},
				xAxis: {
					type: 'category',
					axisLabel: { interval: 0 } // 坐标轴标签间 刻度，0 表示强制全部显示
				},
				yAxis: {
					type: 'value',
					name: chartType ? '单位：%' : '单位：元',
					// min: 0,
					// max: 250,
					interval: 10
					// axisLabel: {
					// 	formatter: '{value} 元'
					// }
				},
				series: seriesList
			}

			// 大图配置参数
			if (isBigChart) {
				let _startDate = new Date(this.startMonth)
				let _endDate = new Date(this.endMonth)
				let _month =
					_startDate.getFullYear() +
					'年' +
					(_startDate.getMonth() + 1) +
					'月' +
					'~' +
					_endDate.getFullYear() +
					'年' +
					(_endDate.getMonth() + 1) +
					'月'
				let typeName = this.curLineType === 1 ? '走势' : '涨跌幅'
				let _compare = this.activeTab1 === 'compare1' ? '同比' : '环比'
				let title =
					_month +
					`全省${this.activeCodeName}材料价格${typeName}${_compare}`
				// 导出文件名
				this.exportName = title
				// 标题
				option.title = {
					text: title,
					left: 'center'
				}
				// 图表间距
				option.grid = {
					top: 70,
					left: 50,
					right: 50,
					bottom: 30
				}
				// 图例
				option.legend = {
					top: 30,
					type: 'scroll',
					left: 'center',
					icon: 'circle'
				}
			}

			myChart.setOption(option)

			if (myChart) {
				window.addEventListener('resize', () => {
					myChart.resize()
				})
			}
		},

		// 点击导出
		doExport() {
			let time = dateFormat('yyyy-MM-dd hh:ss:mm')
			let params
			switch (this.activeTab1) {
				case 'price':
					params = {
						citys: this.tableObj.headerColumns,
						materialPrices: this.tableObj.showData,
						yearAndMonth: this.curDate
					}
					exportExcel(
						'resourcesPriceAh/exportMainMaterialPrice',
						params,
						'主要材料价格明细' + time
					)
					break
				case 'trend':
					let typeName = this.curLineType === 1 ? '走势' : '涨跌幅'
					params = {
						startMonth: this.startMonth,
						endMonth: this.endMonth,
						sname: this.activeCodeName,
						citys: this.tableObj.headerColumns,
						monthPrices: this.tableObj.showData
					}
					exportExcel(
						'resourcesPriceAh/exportMainMaterialsPriceTrend',
						params,
						this.activeCodeName +
							'材料价格' +
							typeName +
							'分析' +
							time
					)
					break
				default:
					params = {
						sname: this.activeCodeName,
						citys: this.tableObj.headerColumns,
						monthPrices: this.chartObj.priceData,
						priceData: this.chartObj.rateData,
						yearAndMonth: this.curDate
					}
					let fileName =
						this.activeTab1 === 'compare1'
							? this.activeCodeName + '材料同比价格分析'
							: this.activeCodeName + '材料环比价格分析'
					exportExcel(
						'resourcesPriceAh/exportMainMaterialsPriceCompare',
						params,
						fileName + time
					)
					return
			}
		},

		// 点击导出图片 --- 预览大图
		doPreview() {
			// 打开弹窗
			this.dialogObj.visible = true
			this.dialogObj.type = 'bigChart'
			this.dialogObj.title = '导出预览'

			// 参数类型判断
			let _type = this.curLineType !== 1
			let _data = _type ? this.chartObj.rateData : this.chartObj.priceData

			// 渲染大图
			switch (this.activeTab1) {
				case 'price':
					setTimeout(() => {
						this.initPriceCharts('bigChart')
					}, 200)

					break
				case 'trend':
					setTimeout(() => {
						this.initTrendCharts(
							this.tableObj.headerColumns,
							_data,
							_type,
							'bigChart'
						)
					}, 200)
					break
				default:
					setTimeout(() => {
						this.initCompareCharts(
							_data,
							this.tableObj.headerColumns,
							_type,
							'bigChart'
						)
					}, 200)
					return
			}
		},

		// 确认导出图片
		saveAsPng(dom, fileName) {
			// 获取dom
			let bigChart = this.$echarts.init(document.getElementById(dom))
			// 创建下载链接dom
			const link = document.createElement('a')
			link.style.display = 'none'
			link.href = bigChart.getDataURL({
				pixelRatio: 1,
				backgroundColor: '#fff'
			})
			// 文件名
			let _fileName = fileName || '导出图片.png'
			link.download = _fileName + '_' + dateFormat('yyyy-MM-dd hh:ss:mm')
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		}
	},
	created() {
		this.$nextTick(() => {
			this.getPageData()

			// 设置 起止时间的 开始年月
			let oldYear = (new Date().getFullYear() - 1).toString()
			let oldMonth = (new Date().getMonth() + 1).toString()
			let startMonth = new Date(oldYear + '-' + oldMonth)
			this.monthArr[0] = dateFormat('yyyy-MM', startMonth)
			this.startMonth = dateFormat('yyyy-MM', startMonth)
		})
	}
}
</script>

<style scoped lang="less">
.comparison-main {
	min-width: 700px;
	overflow-x: auto;
	font-size: 14px;

	.isActive {
		color: #409eff;
		background: #ecf5ff;
		border-color: #b3d8ff;
	}

	.material-tag {
		margin-left: 10px;
		cursor: pointer;
		background: #fff;
		color: #606266;

		&.active {
			background-color: #ecf5ff;
			color: #409eff;
		}
	}

	.w-page-container {
		overflow: auto;
	}

	.comparison-header {
		display: flex;

		.header-title {
			font-size: 18px;
			font-weight: 700;
		}
	}

	.comparison-header-left {
		height: 40px;
		flex: 1;
		white-space: nowrap;
		overflow: auto;
		overflow-y: hidden;
	}

	.comparison-header-center {
		line-height: 30px;

		/deep/ .el-radio {
			margin-right: 20px;
		}
	}

	.comparison-header-right {
		padding-left: 10px;
		margin-left: auto;
		color: #606266;
	}

	.comparison-chart {
		height: 450px;
	}

	.w-table-layout {
		height: auto;
	}

	.bigChart-box {
		height: 520px;
	}
}
.info-box {
	p {
		height: 20px;
		line-height: 20px;
	}
}
</style>
